import { ParseKeys, TOptions } from 'i18next';

// use types from API via data-contract when create/update endpoints expose service contract types
export type DealerOwnedServiceContractType =
	| 'Base'
	| 'Comfort'
	| 'Advanced'
	| 'Other';

export type VolvoOwnedServiceContractType =
	| 'Base'
	| 'Comfort'
	| 'Enhanced'
	| 'Optimum';

export const dealerOwnedServiceContractTypeToTranslationMapping: {
	[K in DealerOwnedServiceContractType]: ParseKeys<
		['serviceContracts'],
		TOptions,
		'serviceContracts'
	>;
} = {
	Base: 'serviceContracts:service-type-base',
	Comfort: 'serviceContracts:service-type-comfort',
	Advanced: 'serviceContracts:service-type-advanced',
	Other: 'serviceContracts:service-type-other',
};

export const volvoOwnedServiceContractTypeToTranslationMapping: {
	[K in VolvoOwnedServiceContractType]: ParseKeys<
		['serviceContracts'],
		TOptions,
		'serviceContracts'
	>;
} = {
	Base: 'serviceContracts:service-type-base',
	Comfort: 'serviceContracts:service-type-comfort',
	Enhanced: 'serviceContracts:service-type-enhanced',
	Optimum: 'serviceContracts:service-type-optimum',
};
